/**
 * 认证绑定 service
 */import { APP_ID } from '../../../constant';
import * as api from '../../api/auth-bind';

/**
 * 获取学校列表数据
 */
export const getSchoolListInfo = () =>
  new Promise((resolve) => {
    api.getSchoolListInfo(APP_ID).then((response) => {
      resolve(response);
    });
  });

/**
 * post 绑定
 * @param params
 * @returns
 */
export const postAuthBindInfo = (params) =>
  new Promise((resolve) => {
    api
      .postAuthBindInfo({
        data: params,
      })
      .then((response) => {
        resolve(response);
      });
  });
